<template>
  <div :class="['cabinet-form_item', { vertical }]">
    <div
      :style="labelStyle"
      :class="labelClass"
      class="label text-base-span-sm"
    >
      <div class="label-content w-full">
        <slot name="label" />
      </div>
    </div>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    labelWidth: {
      type: String,
      default: "30%"
    },
    labelClass: {
      type: String,
      required: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelStyle() {
      return {
        width: this.labelWidth
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/design/mainIncludes";

.cabinet-form_item {
  display: flex;
  align-items: baseline;
  column-gap: 15px;

  @include maxWidth768 {
    flex-direction: column;
    row-gap: 8px;
  }

  &.vertical {
    flex-direction: column;
    //row-gap: 8px;
    row-gap: 0;

    .content {
      margin-top: 12px;
    }
  }

  .label {
    display: flex;
    align-items: center;
    color: $grey-4;
    flex-shrink: 0;

    @include maxWidth768 {
      width: 100%;
      overflow: hidden;
    }

    .label-content {
      display: flex;
      align-items: center;
    }
  }

  .content {
    width: 100%;
    row-gap: 8px;
    display: flex;
    flex-direction: column;
  }
}

</style>
